import CSS from "./static/css/ProductDetail.module.css";
import { useSearchParams } from "react-router-dom";
import useProductDetailSetting from "./hooks/useProductDetailSetting";
import { ProductDetail_Folder_PhotoListEle_Interface, ProductDetail_SelectPhotoListEle_PhotoListEle_Interface } from "./static/interface/ProductDetail.interface";
import { customParseInt, customToast, isAbleAccesser } from "../../Common/ts/commonTools";
import useProductDetailREST from "./hooks/REST/useProductDetailREST";
import { PRODUCT_STATE_CODE_OBJ } from "./static/ts/const";
import { MouseEvent, useEffect, useState } from "react";
import { productStateCodeType } from "./static/interface/ProductList.interface";
import { backPointUrlManagerClass } from "../../Common/ts/appTools";
import ThreeSplitPages from "../../Component/Elements/Page/ThreeSplitPages/ThreeSplitPages";
import UploadImageListViewMode from "../../Component/Elements/UploadImageListViewMode/UploadImageListViewMode";
import ProductInfoCardViewMode from "./components/ProductInfoCardViewMode/ProductInfoCardViewMode";
import { uploadImageListViewMode_imgListSetter } from "../../Component/Elements/UploadImageListViewMode/static/ts/common.tools";
import DetailPageBtnTotalContainer from "./components/DetailPageBtnTotalContainer/DetailPageBtnTotalContainer";
import Overlay from "../../Component/Elements/Overlay/Overlay";
import useHistoryBackContralOverlayState from "../../Component/Elements/Overlay/hooks/useHistoryBackContralOverlayState.hook";
import Button from "../../Component/Elements/Button/Normal/Button";
import Text from "../../Component/Elements/Text/Text";
import EditIcon from "../../Component/Elements/Icon/EditIcon/EditIcon";
import LoopAnimationModal from "../../Component/Elements/LoopAnimationModal/LoopAnimationModal";
import AddAddressBtn from "./components/AddAddressBtn/AddAddressBtn";
import { addressListManagerClass } from "./static/ts/common.tools";
import { useCommonStore } from "../../App";
import { uploadImageListViewMode_folderInfo_Interface } from "../../Component/Elements/UploadImageListViewMode/static/interface/UploadImageListViewMode.interface";
import useIsMobile from "../../Common/hooks/useIsMobile";
import usePhotoImageDataListREST from "./hooks/REST/usePhotoImageDataListREST";
import { FILE_USAGE_CD } from "./static/interface/ProductItemPhoto.interface";
import { mediaFileDataType } from "../../Common/interface/Common.interface";

const addressListManager = new addressListManagerClass();

const backPointUrlManager = new backPointUrlManagerClass();

const ProductDetail = () => {
    const [textTitle, setTextTitle] = useState<string>("");
    const [photoList, setPhotoList] = useState<ProductDetail_Folder_PhotoListEle_Interface[]>([]);
    const [statusCd, setStatusCd] = useState<productStateCodeType>(PRODUCT_STATE_CODE_OBJ.application_not_possible);

    const setHeaderRightNode = useCommonStore((state) => state.setHeaderRightNode);

    // 주소 수정 모드
    const [addressEditMode, setAddressEditMode] = useState<boolean>(false);

    const l_isMobile = useIsMobile();

    const [URLSearchParamsData, SetURLSearchParamsData] = useSearchParams();

    // 선택이 완료된 직후에 진입한 경우인지 체크
    let l_is_done = URLSearchParamsData.get("is_done");

    let l_contract_product_id: number | null = customParseInt(URLSearchParamsData.get("contract_product_id"));

    const l_album_save_id: number | null = customParseInt(URLSearchParamsData.get("album_save_id"));

    const l_photo_upload_id: number | null = customParseInt(URLSearchParamsData.get("photo_upload_id"))

    // 뒤로가기 주소
    const m_back_point = backPointUrlManager.getBackPointUrlAndDecode(URLSearchParamsData);

    // album_save_id는 고객이 사진을 업로드하면 생성된다.
    // photo_upload_id는 편집 사진이 업로드되면 생성된다.
    // 따라서 contract_product_id와 status_cd값이 넘어오는지만 확인한다.
    if(!l_contract_product_id){
        if(m_back_point){
            window.location.href = m_back_point;
        }else{
            window.location.href = "/productList";
        }
    }

    // 위의 null조건을 통과한 후에는 무조건 값이 있는 상태이다. -> 자료형을 교정해준다.
    l_contract_product_id = l_contract_product_id as number;

    const {
        isOpen,
        openOverlay,
        closeOverlay,
    } = useHistoryBackContralOverlayState(false);

    const {
        productDetailData,
        productDetailError,
        productDetailIsLoading,
        productDetailRefetch,
    } = useProductDetailREST({
        contract_product_id: l_contract_product_id,
        album_save_id: l_album_save_id,
        photo_upload_id: l_photo_upload_id
    })

    const {
        productDetailInfoData,
        productOptionDataList,
        folderList,
        initialSelectOptionDataList,
        initialSelectPhotoList,
        initialEditPhotoList,
        addedInfo,
        addressList,
        isSingle,
        isAlbum,
        selectInformationDate,
        isCanReupload,
        tempAddressList,
        setTempAddressList,
        productQty,
        totalAddressQty,
    } = useProductDetailSetting({
        productDetailData,
    })

    useEffect(() => {
        console.log("folderList ============");
        console.log(folderList);
        console.log("================================================");
    }, [folderList])

    // 선택한 사진 데이터 요청
    const {
        photoImageDataListData,
        photoImageDataListError,
        photoImageDataListIsLoading,
        photoImageDataListRefetch,
    } = usePhotoImageDataListREST({
        brand_id: productDetailData?.product_detail_data?.brand_id || 0,
        data_pk: l_contract_product_id || 0,
        file_usage_cd: FILE_USAGE_CD.CUSTOMER_SELECTED_PHOTO,
    })

    // 폴더 이미지 데이터 요청
    const {
        photoImageDataListData: folderImageDataListData,
        photoImageDataListIsLoading: folderImageDataListIsLoading,
        photoImageDataListError: folderImageDataListError,
        photoImageDataListRefetch: folderImageDataListRefetch,
    } = usePhotoImageDataListREST({
        brand_id: productDetailData?.product_detail_data?.brand_id || 0,
        data_pk: productDetailInfoData?.detail_product_id || 0,
        file_usage_cd: FILE_USAGE_CD.PRODUCT_FOLDER,
    })

    const addressEditModeOnHandler = () => {
        setAddressEditMode(true);
    }

    const addressEditModeOffHandler = () => {
        if(!window.confirm("배송지 정보 변경을 취소하시겠습니까?")){
            return;
        }

        setTempAddressList(addressList);
        setAddressEditMode(false);
    }

    function getProductDetailTitleText(status_cd: productStateCodeType){
        let RTN: string = "";

        switch(status_cd){
            case PRODUCT_STATE_CODE_OBJ.application_not_possible:
                break;
            case PRODUCT_STATE_CODE_OBJ.application_possible:
                break;
            case PRODUCT_STATE_CODE_OBJ.application_in_progress:
                RTN = "사진 선택 완료"
                break;
            case PRODUCT_STATE_CODE_OBJ.editing:
                RTN = "사진 편집 중"
                break;
            case PRODUCT_STATE_CODE_OBJ.confirm_request:
                RTN = "사진 편집 승인 요청"
                break;
            case PRODUCT_STATE_CODE_OBJ.edit_end:
                RTN = "편집 완료(상품 제작)"
                break;
            case PRODUCT_STATE_CODE_OBJ.confirm_rejected:
                break;
        }

        return RTN;
    }

    // function getUseingPhotoList(status_cd: productStateCodeType){
    //     let RTN: ProductDetail_Folder_PhotoListEle_Interface[] = [];
    //     switch(status_cd){
    //         case PRODUCT_STATE_CODE_OBJ.application_not_possible:
    //             break;
    //         case PRODUCT_STATE_CODE_OBJ.application_possible:
    //             break;
    //         case PRODUCT_STATE_CODE_OBJ.application_in_progress:
    //             RTN = initialSelectPhotoList;
    //             break;
    //         case PRODUCT_STATE_CODE_OBJ.editing:
    //             RTN = initialSelectPhotoList;
    //             break;
    //         case PRODUCT_STATE_CODE_OBJ.confirm_request:
    //             RTN = initialEditPhotoList;
    //             break;
    //         case PRODUCT_STATE_CODE_OBJ.edit_end:
    //             RTN = initialEditPhotoList;
    //             break;
    //         case PRODUCT_STATE_CODE_OBJ.confirm_rejected:
    //             RTN = initialEditPhotoList;
    //             break;
    //     }
    //     return RTN;
    // }

    const addEmptyAddressHandler = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();

        addressListManager.addNewAddress({
            address_list: tempAddressList,
            data: {
                recipient_name: "",
                recipient_phone: "",
                zip_code: "",
                addr: "",
                building_no: "",
                addr_detail: "",
                product_qty: 1,
            },
            addressListSetter: setTempAddressList,
        })
    }

    useEffect(() => {
        isAbleAccesser({
            allowedUserTypeList: ["C"]
        })

        if(l_is_done === "Y"){
            // 크게 필요하지 않는 알림창이 될지도...
            // customToast.info({
            //     msg: "업로드한 이미지는 30초 후에 화면에 출력됩니다."
            // });

            const m_URLSearchParamsData = new URLSearchParams(URLSearchParamsData);
            m_URLSearchParamsData.delete("is_done");
            SetURLSearchParamsData(m_URLSearchParamsData);
        }
    }, [])

    useEffect(() => {
        // 업로드가 가능한 경우에는 업로드 버튼을 출력시켜준다.
        if(isCanReupload && l_isMobile){
            setHeaderRightNode(
                <EditIcon
                    status_cd={statusCd}
                    contract_product_id={l_contract_product_id || 0}
                    album_save_id={l_album_save_id}
                    photo_upload_id={l_photo_upload_id}
                    isHidden={"web"}
                />
            )
        }else{
            setHeaderRightNode(<></>);
        }
    }, [l_isMobile, isCanReupload, statusCd, l_contract_product_id, l_album_save_id, l_photo_upload_id])

    useEffect(() => {
        if(selectInformationDate){
            setTextTitle(getProductDetailTitleText(selectInformationDate.status_cd));
            setStatusCd(selectInformationDate.status_cd);
        }
    }, [selectInformationDate])

    useEffect(() => {
        console.log("photoImageDataListData ============");
        console.log(photoImageDataListData);
        console.log("================================================");
    }, [photoImageDataListData])

    useEffect(() => {
        if(folderList.length > 0 && photoImageDataListData && photoImageDataListData.data.length > 0){
            const m_photoList: ProductDetail_Folder_PhotoListEle_Interface[] = [];

            for(let index = 0 ; index < folderList.length ; index++){
                const m_photo_list: ProductDetail_SelectPhotoListEle_PhotoListEle_Interface[] = photoImageDataListData.data[0]
                    .upload_file_detail_data
                    .filter((item) => {
                        return item.folder_id == folderList[index].folder_id.toString();
                    })
                    .map((item) => {
                        return({
                            album_save_id: l_album_save_id || 0,
                            file_name: item.file_nm,
                            file_type: item.file_ext as mediaFileDataType,
                            folder_id: folderList[index].folder_id,
                            small_img_url: item.small_img,
                            middle_img_url: item.middle_img,
                            org_img_url: item.org_img,
                        })
                    });

                const photo_list: ProductDetail_Folder_PhotoListEle_Interface = {
                    folder_id: folderList[index].folder_id,
                    folder_name: folderList[index].folder_name,
                    folder_image_url: folderList[index].folder_image_url,
                    min_photo_count: folderList[index].min_photo_count,
                    max_photo_count: folderList[index].max_photo_count,
                    photo_list: m_photo_list,
                };

                m_photoList.push(photo_list);
            }

            setPhotoList(m_photoList);
        }
    }, [photoImageDataListData, folderImageDataListData, folderList])

    return(
        <ThreeSplitPages
            title={textTitle}

            centerContainerNode={
                <UploadImageListViewMode
                    folderInfoList={
                        folderList.map((folder_item) => {
                            const RTN: uploadImageListViewMode_folderInfo_Interface = {
                                folder_name: folder_item.folder_name,
                                folder_id: folder_item.folder_id,
                                middle_img_url: folder_item.middle_img_url,
                                small_img_url: folder_item.small_img_url,
                                img_list: uploadImageListViewMode_imgListSetter({
                                    folder_id: folder_item.folder_id,
                                    all_photo_list: photoList
                                })
                            }

                            return (RTN);
                        })
                    }
                    isComfrimMode={false}
                    isSingle={isSingle}
                />
            }

            isRightHidden={"mobile"}
            rightContainerNode={
                <div className={CSS.l_ProductDetail_rightContainer}>
                    <ProductInfoCardViewMode
                        product_name={productDetailInfoData?.product_name || ""}
                        is_view_babyinfo={isAlbum}
                        selectedOptionData={initialSelectOptionDataList}
                        addedInfo={addedInfo}
                        address_list={tempAddressList}
                        setAddressList={setTempAddressList}
                        isEditMode={addressEditMode}
                        productQty={productQty}
                        totalAddressQty={totalAddressQty}
                    />

                    {
                        addressEditMode
                        &&  <AddAddressBtn
                                addEmptyAddressHandler={addEmptyAddressHandler}
                                is_visible={productQty > totalAddressQty}
                            />
                    }

                    {
                        addressEditMode
                        ?   <div className={`${CSS.l_buttonContainer} ${CSS.addressEditMode}`}>
                                <Button
                                    size={"size3"}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        addressEditModeOffHandler();
                                    }}
                                    class_name_list={[CSS.l_gridArea_cancelBtn]}
                                    preset={"cancel"}
                                >
                                    취소
                                </Button>

                                <Button
                                    size={"size3"}
                                    class_name_list={[CSS.l_gridArea_saveBtn]}
                                    onClick={
                                        addressListManager.requestSetAddress.bind(null, {
                                            album_save_id: l_album_save_id,
                                            addr_list: tempAddressList,
                                            successHandler: () => {
                                                productDetailRefetch();

                                                setAddressEditMode(false);
                                            },
                                        })
                                    }
                                    preset={"save"}
                                >
                                    저장
                                </Button>
                            </div>
                        :   <div className={`${CSS.l_buttonContainer} ${CSS.addressViewMode}`}>
                                <DetailPageBtnTotalContainer
                                    contract_product_id={l_contract_product_id}
                                    album_save_id={l_album_save_id}
                                    photo_upload_id={l_photo_upload_id}
                                    status_cd={statusCd}
                                    isCanReupload={isCanReupload}
                                    class_name_list={[CSS.l_gridArea_detailPageBtn]}
                                />

                                <Button
                                    size={"size3"}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        addressEditModeOnHandler();
                                    }}
                                    class_name_list={[CSS.l_gridArea_addressEditModeOnBtn]}
                                    preset={"edit"}
                                >
                                    배송지 변경
                                </Button>
                            </div>
                    }
                </div>
            }

            bottomContainerNode={
                <>
                    {
                        l_isMobile
                        &&  <>
                                <div className={CSS.l_mobileBottomContainer}>
                                    <Button
                                        onClick={openOverlay}
                                        preset={"detail_modal"}
                                    >
                                        <Text color={"secondary"}>
                                            상세 정보 보기
                                        </Text>
                                    </Button>

                                    <DetailPageBtnTotalContainer
                                        contract_product_id={l_contract_product_id}
                                        album_save_id={l_album_save_id}
                                        photo_upload_id={l_photo_upload_id}
                                        status_cd={statusCd}
                                    />
                                </div>

                                <Overlay
                                    isOverlayOpen={isOpen}
                                    overlayCloseHandler={closeOverlay}
                                >
                                    <ProductInfoCardViewMode
                                        product_name={productDetailInfoData?.product_name || ""}
                                        is_view_babyinfo={isAlbum}
                                        selectedOptionData={initialSelectOptionDataList}
                                        addedInfo={addedInfo}
                                        address_list={tempAddressList}
                                        setAddressList={setTempAddressList}
                                        isRemoveOutline={true}
                                        isEditMode={addressEditMode}
                                        productQty={productQty}
                                        totalAddressQty={totalAddressQty}
                                    />

                                    {
                                        addressEditMode
                                        &&  <AddAddressBtn
                                                addEmptyAddressHandler={addEmptyAddressHandler}
                                                is_visible={productQty > totalAddressQty}
                                            />
                                    }

                                    {
                                        addressEditMode
                                        ?   <div className={`${CSS.l_buttonContainer} ${CSS.addressEditMode}`}>
                                                <Button
                                                    size={"size3"}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        addressEditModeOffHandler();
                                                    }}
                                                    class_name_list={[CSS.l_gridArea_cancelBtn]}
                                                    preset={"cancel"}
                                                >
                                                    취소
                                                </Button>

                                                <Button
                                                    size={"size3"}
                                                    class_name_list={[CSS.l_gridArea_saveBtn]}
                                                    onClick={
                                                        addressListManager.requestSetAddress.bind(null, {
                                                            album_save_id: l_album_save_id,
                                                            addr_list: tempAddressList,
                                                            successHandler: () => {
                                                                productDetailRefetch();

                                                                setAddressEditMode(false);
                                                            },
                                                        })
                                                    }
                                                    preset={"save"}
                                                >
                                                    저장
                                                </Button>
                                            </div>
                                        :   <div className={`${CSS.l_buttonContainer} ${CSS.addressViewMode}`}>
                                                <Button
                                                    size={"size3"}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        addressEditModeOnHandler();
                                                    }}
                                                    class_name_list={[CSS.l_gridArea_addressEditModeOnBtn]}
                                                >
                                                    배송지 변경
                                                </Button>
                                            </div>
                                    }
                                </Overlay>
                            </>
                    }


                    <LoopAnimationModal
                        isModalOpen={productDetailIsLoading}
                    />
                </>
            }
        />
    )
}

export default ProductDetail;